import { render, staticRenderFns } from "./NavbarDropdownItem.vue?vue&type=template&id=7f860d18&scoped=true"
import script from "./NavbarDropdownItem.vue?vue&type=script&lang=ts"
export * from "./NavbarDropdownItem.vue?vue&type=script&lang=ts"
import style0 from "./NavbarDropdownItem.vue?vue&type=style&index=0&id=7f860d18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f860d18",
  null
  
)

export default component.exports